[
	{
		"id": "emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7",
		"name": "DinoDance",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dcd06b30a5c24f6eb871e8f5edbd44f7/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static", "animated"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_1f524be9838146e3bc9e529c17f797d3",
		"name": "NiceTry",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1f524be9838146e3bc9e529c17f797d3/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1f524be9838146e3bc9e529c17f797d3/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1f524be9838146e3bc9e529c17f797d3/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_adfadf0ae06a4258adc865761746b227",
		"name": "LionOfYara",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_adfadf0ae06a4258adc865761746b227/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_adfadf0ae06a4258adc865761746b227/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_adfadf0ae06a4258adc865761746b227/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_53f6a6af8b0e453d874bbefee49b3e73",
		"name": "NewRecord",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_53f6a6af8b0e453d874bbefee49b3e73/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_53f6a6af8b0e453d874bbefee49b3e73/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_53f6a6af8b0e453d874bbefee49b3e73/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_665235901db747b1bd395a5f1c0ab8a9",
		"name": "Lechonk",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_665235901db747b1bd395a5f1c0ab8a9/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_665235901db747b1bd395a5f1c0ab8a9/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_665235901db747b1bd395a5f1c0ab8a9/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_291135bb36d24d33bf53860128b5095c",
		"name": "Getcamped",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_291135bb36d24d33bf53860128b5095c/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_291135bb36d24d33bf53860128b5095c/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_291135bb36d24d33bf53860128b5095c/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_fcbeed664f7c47d6ba3b57691275ef51",
		"name": "SUBprise",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_fcbeed664f7c47d6ba3b57691275ef51/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_fcbeed664f7c47d6ba3b57691275ef51/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_fcbeed664f7c47d6ba3b57691275ef51/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_7f9b025d534544afaf679e13fbd47b88",
		"name": "FallHalp",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7f9b025d534544afaf679e13fbd47b88/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7f9b025d534544afaf679e13fbd47b88/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7f9b025d534544afaf679e13fbd47b88/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_2734f1a85677416a9d8f846a2d1b4721",
		"name": "FallCry",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_2734f1a85677416a9d8f846a2d1b4721/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_2734f1a85677416a9d8f846a2d1b4721/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_2734f1a85677416a9d8f846a2d1b4721/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_dee4ecfb7f0940bead9765da02c57ca9",
		"name": "FallWinning",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dee4ecfb7f0940bead9765da02c57ca9/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dee4ecfb7f0940bead9765da02c57ca9/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_dee4ecfb7f0940bead9765da02c57ca9/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_0be25a1663bd472495b91e0302cec166",
		"name": "MechaRobot",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0be25a1663bd472495b91e0302cec166/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0be25a1663bd472495b91e0302cec166/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0be25a1663bd472495b91e0302cec166/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_b0c6ccb3b12b4f99a9cc83af365a09f1",
		"name": "ImTyping",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_b0c6ccb3b12b4f99a9cc83af365a09f1/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_b0c6ccb3b12b4f99a9cc83af365a09f1/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_b0c6ccb3b12b4f99a9cc83af365a09f1/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_819621bcb8f44566a1bd8ea63d06c58f",
		"name": "Shush",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_819621bcb8f44566a1bd8ea63d06c58f/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_c0c9c932c82244ff920ad2134be90afb",
		"name": "MyAvatar",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_c0c9c932c82244ff920ad2134be90afb/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_c0c9c932c82244ff920ad2134be90afb/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_c0c9c932c82244ff920ad2134be90afb/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_f202746ed88f4e7c872b50b1f7fd78cc",
		"name": "PizzaTime",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_f202746ed88f4e7c872b50b1f7fd78cc/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_f202746ed88f4e7c872b50b1f7fd78cc/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_f202746ed88f4e7c872b50b1f7fd78cc/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_ecb0bfd49b3c4325864b948d46c8152b",
		"name": "LaundryBasket",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_ecb0bfd49b3c4325864b948d46c8152b/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_ecb0bfd49b3c4325864b948d46c8152b/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_ecb0bfd49b3c4325864b948d46c8152b/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_a2dfbbbbf66f4a75b0f53db841523e6c",
		"name": "ModLove",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a2dfbbbbf66f4a75b0f53db841523e6c/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a2dfbbbbf66f4a75b0f53db841523e6c/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_a2dfbbbbf66f4a75b0f53db841523e6c/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_e02650251d204198923de93a0c62f5f5",
		"name": "PotFriend",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_e02650251d204198923de93a0c62f5f5/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_e02650251d204198923de93a0c62f5f5/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_e02650251d204198923de93a0c62f5f5/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_031bf329c21040a897d55ef471da3dd3",
		"name": "Jebasted",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_031bf329c21040a897d55ef471da3dd3/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_031bf329c21040a897d55ef471da3dd3/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_031bf329c21040a897d55ef471da3dd3/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_30050f4353aa4322b25b6b044703e5d1",
		"name": "PogBones",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_30050f4353aa4322b25b6b044703e5d1/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_30050f4353aa4322b25b6b044703e5d1/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_30050f4353aa4322b25b6b044703e5d1/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_4c39207000564711868f3196cc0a8748",
		"name": "PoroSad",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4c39207000564711868f3196cc0a8748/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4c39207000564711868f3196cc0a8748/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4c39207000564711868f3196cc0a8748/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_7c5d25facc384c47963d25a5057a0b40",
		"name": "KEKHeim",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7c5d25facc384c47963d25a5057a0b40/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7c5d25facc384c47963d25a5057a0b40/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_7c5d25facc384c47963d25a5057a0b40/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_4acac638cffb4db49f376059f7077dae",
		"name": "CaitlynS",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4acac638cffb4db49f376059f7077dae/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4acac638cffb4db49f376059f7077dae/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_4acac638cffb4db49f376059f7077dae/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_8b0ac3eee4274a75868e3d0686d7b6f7",
		"name": "HarleyWink",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_8b0ac3eee4274a75868e3d0686d7b6f7/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_8b0ac3eee4274a75868e3d0686d7b6f7/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_8b0ac3eee4274a75868e3d0686d7b6f7/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_1fda4a1b40094c93af334f8b60868a7c",
		"name": "WhySoSerious",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1fda4a1b40094c93af334f8b60868a7c/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1fda4a1b40094c93af334f8b60868a7c/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_1fda4a1b40094c93af334f8b60868a7c/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_d9567e500d78441793bee538dcabc1da",
		"name": "DarkKnight",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_d9567e500d78441793bee538dcabc1da/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_d9567e500d78441793bee538dcabc1da/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_d9567e500d78441793bee538dcabc1da/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_89f3f0761c7b4f708061e9e4be3b7d17",
		"name": "FamilyMan",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_89f3f0761c7b4f708061e9e4be3b7d17/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_89f3f0761c7b4f708061e9e4be3b7d17/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_89f3f0761c7b4f708061e9e4be3b7d17/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_0ebc590ba68447269831af61d8bc9e0d",
		"name": "RyuChamp",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0ebc590ba68447269831af61d8bc9e0d/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0ebc590ba68447269831af61d8bc9e0d/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_0ebc590ba68447269831af61d8bc9e0d/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "emotesv2_535e40afa0b34a9481997627b1b47d96",
		"name": "HungryPaimon",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_535e40afa0b34a9481997627b1b47d96/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_535e40afa0b34a9481997627b1b47d96/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/emotesv2_535e40afa0b34a9481997627b1b47d96/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827377",
		"name": "TransgenderPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827377/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827370",
		"name": "PansexualPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827370/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827356",
		"name": "NonbinaryPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827356/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827356/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827356/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827340",
		"name": "LesbianPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827340/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827340/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827340/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827332",
		"name": "IntersexPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827332/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827326",
		"name": "GenderFluidPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827326/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827321",
		"name": "GayPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827321/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827313",
		"name": "BisexualPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827313/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "307827267",
		"name": "AsexualPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/307827267/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "305954156",
		"name": "PogChamp",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/305954156/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/305954156/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/305954156/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "304489309",
		"name": "GlitchNRG",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/304489309/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "304489128",
		"name": "GlitchLit",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/304489128/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/304489128/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/304489128/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "304486324",
		"name": "StinkyGlitch",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/304486324/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/304486324/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/304486324/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "304486301",
		"name": "GlitchCat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/304486301/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "302628617",
		"name": "FootGoal",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/302628617/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/302628617/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/302628617/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "302628613",
		"name": "FootYellow",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/302628613/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/302628613/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/302628613/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "302628600",
		"name": "FootBall",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/302628600/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/302628600/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/302628600/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "302537250",
		"name": "BlackLivesMatter",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/302537250/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/302537250/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/302537250/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "302426269",
		"name": "ExtraLife",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/302426269/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/302426269/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/302426269/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "301696583",
		"name": "VirtualHug",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/301696583/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/301696583/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/301696583/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "301428702",
		"name": "BOP",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/301428702/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/301428702/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/301428702/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "300116350",
		"name": "SingsNote",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/300116350/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/300116350/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/300116350/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "300116349",
		"name": "SingsMic",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/300116349/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/300116349/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/300116349/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "300116344",
		"name": "TwitchSings",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/300116344/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/300116344/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/300116344/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "2113050",
		"name": "SoonerLater",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/2113050/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1713825",
		"name": "HolidayTree",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1713825/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1713825/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1713825/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1713822",
		"name": "HolidaySanta",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1713822/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1713822/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1713822/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1713819",
		"name": "HolidayPresent",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1713819/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1713819/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1713819/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1713816",
		"name": "HolidayLog",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1713816/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1713816/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1713816/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1713813",
		"name": "HolidayCookie",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1713813/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1713813/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1713813/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1584743",
		"name": "GunRun",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1584743/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1584743/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1584743/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1547903",
		"name": "PixelBob",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1547903/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441289",
		"name": "FBPenalty",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441289/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441285",
		"name": "FBChallenge",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441285/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441281",
		"name": "FBCatch",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441281/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441276",
		"name": "FBBlock",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441276/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441273",
		"name": "FBSpiral",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441273/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441271",
		"name": "FBPass",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441271/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1441261",
		"name": "FBRun",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1441261/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1290325",
		"name": "MaxLOL",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1290325/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1290325/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1290325/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1220086",
		"name": "TwitchRPG",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1220086/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1220086/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1220086/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1003190",
		"name": "PinkMercy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1003190/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1003190/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1003190/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1003189",
		"name": "MercyWing2",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1003189/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1003189/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1003189/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1003187",
		"name": "MercyWing1",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1003187/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1003187/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1003187/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "965738",
		"name": "PartyHat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/965738/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/965738/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/965738/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "959018",
		"name": "EarthDay",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/959018/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/959018/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/959018/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "864205",
		"name": "TombRaid",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/864205/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/864205/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/864205/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "724216",
		"name": "PopCorn",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/724216/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/724216/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/724216/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "626795",
		"name": "FBtouchdown",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/626795/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/626795/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/626795/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "508650",
		"name": "TPFufun",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/508650/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/508650/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/508650/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "479745",
		"name": "TwitchVotes",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/479745/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/479745/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/479745/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "461298",
		"name": "DarkMode",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/461298/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/461298/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/461298/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "446979",
		"name": "HSWP",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/446979/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/446979/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/446979/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "444572",
		"name": "HSCheers",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/444572/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/444572/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/444572/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "425688",
		"name": "PowerUpL",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/425688/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/425688/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/425688/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "425671",
		"name": "PowerUpR",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/425671/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/425671/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/425671/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "425618",
		"name": "LUL",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/425618/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/425618/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/425618/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "376765",
		"name": "EntropyWins",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/376765/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/376765/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/376765/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "323914",
		"name": "TPcrunchyroll",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/323914/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/323914/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/323914/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "196892",
		"name": "TwitchUnity",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/196892/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/196892/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/196892/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "191767",
		"name": "Squid4",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/191767/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/191767/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/191767/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "191764",
		"name": "Squid3",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/191764/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/191764/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/191764/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "191763",
		"name": "Squid2",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/191763/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/191763/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/191763/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "191762",
		"name": "Squid1",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/191762/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/191762/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/191762/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "191313",
		"name": "CrreamAwk",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/191313/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/191313/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/191313/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "166266",
		"name": "CarlSmile",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/166266/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/166266/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/166266/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "166263",
		"name": "TwitchLit",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/166263/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/166263/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/166263/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160404",
		"name": "TehePelo",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160404/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160404/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160404/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160403",
		"name": "TearGlove",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160403/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160403/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160403/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160402",
		"name": "SabaPing",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160402/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160402/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160402/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160401",
		"name": "PunOko",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160401/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160401/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160401/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160400",
		"name": "KonCha",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160400/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160400/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160400/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160397",
		"name": "Kappu",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160397/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160397/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160397/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160396",
		"name": "InuyoFace",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160396/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160396/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160396/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160395",
		"name": "BigPhish",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160395/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160395/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160395/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160394",
		"name": "BegWan",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160394/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160394/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160394/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "160392",
		"name": "ThankEgg",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/160392/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/160392/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/160392/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "156787",
		"name": "MorphinTime",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/156787/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/156787/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/156787/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "145315",
		"name": "TheIlluminati",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/145315/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/145315/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/145315/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "143490",
		"name": "TBAngel",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/143490/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/143490/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/143490/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "142140",
		"name": "MVGame",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/142140/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/142140/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/142140/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "138325",
		"name": "NinjaGrumpy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/138325/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/138325/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/138325/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "135393",
		"name": "PartyTime",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/135393/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/135393/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/135393/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "134256",
		"name": "RlyTho",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/134256/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/134256/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/134256/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "134255",
		"name": "UWot",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/134255/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/134255/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/134255/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "134254",
		"name": "YouDontSay",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/134254/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/134254/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/134254/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "133537",
		"name": "KAPOW",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/133537/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/133537/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/133537/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "133468",
		"name": "ItsBoshyTime",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/133468/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/133468/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/133468/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "123171",
		"name": "CoolStoryBob",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/123171/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/123171/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/123171/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "120232",
		"name": "TriHard",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/120232/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/120232/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/120232/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "118772",
		"name": "SuperVinlin",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/118772/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/118772/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/118772/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "117701",
		"name": "FreakinStinkin",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/117701/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/117701/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/117701/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "117484",
		"name": "Poooound",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/117484/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/117484/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/117484/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "116625",
		"name": "CurseLit",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/116625/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/116625/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/116625/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "115234",
		"name": "BatChest",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/115234/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/115234/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/115234/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "115233",
		"name": "BrainSlug",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/115233/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/115233/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/115233/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "115075",
		"name": "PrimeMe",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/115075/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/115075/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/115075/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114876",
		"name": "StrawBeary",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114876/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114876/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114876/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114870",
		"name": "RaccAttack",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114870/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114870/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114870/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114856",
		"name": "UncleNox",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114856/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114856/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114856/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114847",
		"name": "WTRuck",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114847/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114847/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114847/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114846",
		"name": "TooSpicy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114846/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114846/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114846/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114836",
		"name": "Jebaited",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114836/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114836/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114836/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114835",
		"name": "DogFace",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114835/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114835/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114835/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "114738",
		"name": "BlargNaut",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/114738/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/114738/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/114738/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "112292",
		"name": "TakeNRG",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/112292/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/112292/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/112292/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "112291",
		"name": "GivePLZ",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/112291/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/112291/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/112291/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "112290",
		"name": "imGlitch",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/112290/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/112290/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/112290/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "112289",
		"name": "pastaThat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/112289/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/112289/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/112289/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "112288",
		"name": "copyThis",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/112288/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/112288/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/112288/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "111792",
		"name": "UnSane",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/111792/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/111792/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/111792/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "111700",
		"name": "DatSheffy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/111700/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/111700/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/111700/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "111351",
		"name": "TheTarFu",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/111351/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/111351/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/111351/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "111300",
		"name": "PicoMause",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/111300/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/111300/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/111300/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "111119",
		"name": "TinyFace",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/111119/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/111119/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/111119/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "110734",
		"name": "DxCat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/110734/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/110734/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/110734/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "107030",
		"name": "RuleFive",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/107030/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/107030/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/107030/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "106294",
		"name": "VoteNay",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/106294/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/106294/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/106294/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "106293",
		"name": "VoteYea",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/106293/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/106293/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/106293/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "102556",
		"name": "PJSugar",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/102556/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/102556/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/102556/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "102242",
		"name": "DoritosChip",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/102242/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/102242/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/102242/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "100590",
		"name": "OpieOP",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/100590/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/100590/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/100590/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "98562",
		"name": "FutureMan",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/98562/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/98562/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/98562/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "90129",
		"name": "ChefFrank",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/90129/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/90129/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/90129/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "90076",
		"name": "StinkyCheese",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/90076/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/90076/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/90076/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "90075",
		"name": "NomNom",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/90075/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/90075/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/90075/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "89945",
		"name": "SmoocherZ",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/89945/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/89945/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/89945/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "84608",
		"name": "cmonBruh",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/84608/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/84608/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/84608/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81997",
		"name": "KappaWealth",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81997/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81997/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81997/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81636",
		"name": "MikeHogu",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81636/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81636/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81636/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81274",
		"name": "VoHiYo",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81274/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81274/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81274/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81273",
		"name": "KomodoHype",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81273/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81273/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81273/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81249",
		"name": "SeriousSloth",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81249/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81249/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81249/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81248",
		"name": "OSFrog",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81248/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81248/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81248/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "81103",
		"name": "OhMyDog",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/81103/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/81103/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/81103/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "74510",
		"name": "KappaClaus",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/74510/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/74510/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/74510/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "70433",
		"name": "KappaRoss",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/70433/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/70433/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/70433/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "68856",
		"name": "MingLee",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/68856/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/68856/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/68856/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "64138",
		"name": "SeemsGood",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/64138/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/64138/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/64138/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "62836",
		"name": "twitchRaid",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/62836/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/62836/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/62836/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "62835",
		"name": "bleedPurple",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/62835/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/62835/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/62835/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "62834",
		"name": "duDudu",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/62834/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/62834/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/62834/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "62833",
		"name": "riPepperonis",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/62833/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/62833/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/62833/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "58765",
		"name": "NotLikeThis",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/58765/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/58765/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/58765/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "58135",
		"name": "DendiFace",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/58135/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/58135/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/58135/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "58127",
		"name": "CoolCat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/58127/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/58127/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/58127/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "55338",
		"name": "KappaPride",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/55338/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/55338/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/55338/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "52492",
		"name": "ShadyLulu",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/52492/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/52492/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/52492/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "51838",
		"name": "ArgieB8",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/51838/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/51838/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/51838/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "49106",
		"name": "CorgiDerp",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/49106/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/49106/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/49106/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "38586",
		"name": "PraiseIt",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/38586/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/38586/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/38586/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "38436",
		"name": "TTours",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/38436/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/38436/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/38436/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "35063",
		"name": "mcaT",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/35063/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/35063/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/35063/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "34875",
		"name": "NotATK",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/34875/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/34875/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/34875/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "30259",
		"name": "HeyGuys",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/30259/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/30259/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/30259/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "30134",
		"name": "Mau5",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/30134/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/30134/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/30134/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "28328",
		"name": "PRChase",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/28328/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/28328/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/28328/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "28087",
		"name": "WutFace",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/28087/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/28087/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/28087/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "27602",
		"name": "BuddhaBar",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/27602/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/27602/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/27602/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "27509",
		"name": "PermaSmug",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/27509/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/27509/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/27509/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "22998",
		"name": "panicBasket",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/22998/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/22998/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/22998/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "22639",
		"name": "BabyRage",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/22639/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/22639/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/22639/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "20225",
		"name": "HassaanChop",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/20225/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/20225/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/20225/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "7427",
		"name": "TheThing",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/7427/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/7427/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/7427/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "4339",
		"name": "EleGiggle",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/4339/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/4339/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/4339/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "4338",
		"name": "RitzMitz",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/4338/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/4338/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/4338/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "4337",
		"name": "YouWHY",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/4337/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/4337/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/4337/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "4240",
		"name": "PipeHype",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/4240/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/4240/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/4240/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "4057",
		"name": "BrokeBack",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/4057/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/4057/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/4057/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "3792",
		"name": "ANELE",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/3792/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/3792/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/3792/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "3668",
		"name": "PanicVis",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/3668/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/3668/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/3668/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "3632",
		"name": "GrammarKing",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/3632/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/3632/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/3632/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "3412",
		"name": "PeoplesChamp",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/3412/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/3412/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/3412/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1906",
		"name": "SoBayed",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1906/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1906/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1906/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1904",
		"name": "BigBrother",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1904/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1904/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1904/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1902",
		"name": "Keepo",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1902/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1902/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1902/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1901",
		"name": "Kippa",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1901/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1901/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1901/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1900",
		"name": "RalpherZ",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1900/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1900/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1900/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1899",
		"name": "TF2John",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1899/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1899/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1899/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1898",
		"name": "ThunBeast",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1898/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1898/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1898/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "1896",
		"name": "WholeWheat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/1896/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/1896/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/1896/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "973",
		"name": "DAESuppy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/973/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/973/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/973/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "360",
		"name": "FailFish",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/360/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/360/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/360/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "357",
		"name": "HotPokket",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/357/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/357/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/357/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "354",
		"name": "4Head",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/354/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/354/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/354/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "245",
		"name": "ResidentSleeper",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/245/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/245/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/245/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "244",
		"name": "FUNgineer",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/244/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/244/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/244/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "92",
		"name": "PMSTwin",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/92/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/92/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/92/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "87",
		"name": "ShazBotstix",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/87/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/87/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/87/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "86",
		"name": "BibleThump",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/86/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/86/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/86/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "74",
		"name": "AsianGlow",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/74/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/74/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/74/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "73",
		"name": "DBstyle",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/73/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/73/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/73/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "69",
		"name": "BloodTrail",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/69/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/69/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/69/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "66",
		"name": "OneHand",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/66/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/66/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/66/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "65",
		"name": "FrankerZ",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/65/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/65/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/65/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "52",
		"name": "SMOrc",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/52/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/52/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/52/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "50",
		"name": "ArsonNoSexy",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/50/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/50/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/50/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "47",
		"name": "PunchTrees",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/47/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/47/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/47/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "46",
		"name": "SSSsss",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/46/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/46/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/46/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "41",
		"name": "Kreygasm",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/41/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/41/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/41/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "40",
		"name": "KevinTurtle",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/40/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/40/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/40/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "36",
		"name": "PJSalt",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/36/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/36/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/36/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "34",
		"name": "SwiftRage",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/34/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/34/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/34/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "33",
		"name": "DansGame",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/33/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/33/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/33/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "32",
		"name": "GingerPower",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/32/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/32/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/32/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "30",
		"name": "BCWarrior",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/30/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/30/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/30/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "28",
		"name": "MrDestructoid",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/28/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/28/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/28/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "26",
		"name": "JonCarnage",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/26/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/26/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/26/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "25",
		"name": "Kappa",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/25/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/25/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/25/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "22",
		"name": "RedCoat",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/22/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/22/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/22/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "18",
		"name": "TheRinger",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/18/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/18/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/18/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "17",
		"name": "StoneLightning",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/17/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/17/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/17/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "16",
		"name": "OptimizePrime",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/16/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/16/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/16/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	},
	{
		"id": "15",
		"name": "JKanStyle",
		"images": {
			"url_1x": "https://static-cdn.jtvnw.net/emoticons/v2/15/static/light/1.0",
			"url_2x": "https://static-cdn.jtvnw.net/emoticons/v2/15/static/light/2.0",
			"url_4x": "https://static-cdn.jtvnw.net/emoticons/v2/15/static/light/3.0"
		},
		"emote_type": "globals",
		"emote_set_id": "0",
		"owner_id": "0",
		"format": ["static"],
		"scale": ["1.0", "2.0", "3.0"],
		"theme_mode": ["light", "dark"]
	}
]
